<div class="headings">
  <div class="px-title">
    Home
  </div>
  <div class="px-subtitle">
    All integrated apps in one place
  </div>
</div>
<div class="overview-container">
  <div class="head showLoader" *ngIf="!hasAppListBeenModifiedByUsage && !appList.length">
    <div id="hansel-loader" style="position: relative; min-height: 412px; background:#fff; margin-top: 5.5em;">
      <app-px-loader></app-px-loader>
    </div>
  </div>
  <div class="head" *ngIf="!appList.length && hasAppListBeenModifiedByUsage">

    <button class="invite-link tertiary-btn" mat-button (click)="openAddUserForm()">INVITE TEAM MEMBER</button>

    <div class="txt1">Welcome to Netcore Product Experience<span *ngIf="userData.name">,
        {{userData.name.split(' ')[0]}}.</span></div>

    <div class="txt2 mt-4">
      <div>Get started by adding Netcore Product Experience to your Apps.</div>
      <div class="mt-1">Our core SDK unlocks most features and include analytics for all apps</div>
    </div>
    <div class="bottom-cont">
      <div class="txt3">Create an App to Get Started</div>
      <div class="action-btns mt-3">
        <button class="cta-btn" mat-button
          (click)="navigateTo({'href' : '/settings', 'cta': CREATE_CTA ,'queryParams' : {'createApp' : true}})">
          CREATE APP
        </button>
      </div>
    </div>

    <div class="illustration"></div>
  </div>
  <div class="head app-head" id="app-head" *ngIf="appList.length && hasAppListBeenModifiedByUsage">
    <div class="invite-link tertiary-btn" mat-button (click)="openAddUserForm()">INVITE USERS</div>
    <div class="px-heading-1 text-center">Hi <span *ngIf="userData.name">{{ userData.name.split(' ')[0]}}!</span>
    </div>
    <div class="txt2">Here’s the list of your recent Apps</div>
    <div class="app-list">
      <ng-container *ngFor="let app of filterAppListByLimit(10); let i=index;">
        <li class="card text-decoration-none" (mouseover)="setHoverTrue($event, app)"
          (mouseleave)="setHoverFalse($event, app)" (click)="redirectToAppJourneysPage(app)">
          <div class="common-part">
            <div class="title">
              <span class="breadcrumb-app">
                <app-platform-icon class="d-inline-block" [iconSize]="'24px'" [platform]="app.os"></app-platform-icon>
              </span>
              <span class="app-name" [ngClass]="{'settingIconPresent': shouldShowUploadFeature}">
                <span [matTooltip]="app.name" [matTooltipPosition]="'above'" matTooltipClass="above">{{app.name}}</span>
              </span>
              <i class="material-icons setting-icon icon-button-dark" *ngIf="shouldShowUploadFeature"
                (click)="redirectToAppsettings(app, $event);">
                settings
              </i>
            </div>
          </div>
          <div class="show-without-hover">
            <span class="app-type">
              <span>{{ this.getAppPlatformTitle(app.os) }}</span>
              App
            </span>
          </div>
        </li>
      </ng-container>
    </div>
    <div class="illustration"></div>
    <div class="bottom-container">
      <div class="action-btns mt-3">
        <button class="link-btn" mat-button *ngIf="appList.length > 5" (click)="handleAppLimit()">
          {{ shouldStickToAppLimit ? 'Show More' : 'Show Less' }}
        </button>
      </div>
    </div>
  </div>


  <div class="body">
    <ng-container *ngFor="let card of cards; let i=index;">
      <a class="card text-decoration-none" *ngIf="!card.shouldBeHidden"
        (click)="navigateTo({'href' : card.href, 'queryParams': card.queryParams, 'cta': card.alias})" appDisableFeature
        [callbackFromDirective]="handleCallbackClickListener"
        [pathString]="card.parentFeature + '.' + card.featureName">
        <i class="material-icons lock-icon"
          *ngIf="(lockedPagesForNoApp.includes(card.alias) && !appList.length)">lock</i>
        <img *ngIf="card.showPremium" src="/assets/images/prompts/premium.png" class="premium-tag">
        <div class="top-txt">{{card.headTitle}}</div>
        <div>
          <img class="img" [src]="card.img">
        </div>
        <div class="bottom">
          <div class="txt1">{{card.bottomTitle}}</div>
          <div class="txt2">{{card.desc}}</div>
        </div>
      </a>
    </ng-container>
  </div>
</div>
